const Layout = {
  description:
    'VoteWise is a central hub for factual, unbiased election information, helping Australians stay informed and vote with confidence.',
};

export default Layout;
